export default __webpack_public_path__ + "static/media/Statistics_2011.e953712b.zip";